import { Injectable } from '@angular/core';
import {
  AppConfigService as AppConfig,
  Configuration
} from '../services/init/app-config.service';
import { UserApiConstant } from '../constants/parmed-api.constant';
import { BaseApi } from './base-api';

@Injectable()
export class UserApi extends BaseApi {
  /******************Properties******************/
  readonly GET_ACCOUNTS_URL: string = UserApiConstant.GET_ACCOUNTS;
  readonly SAVE_ACCOUNT_SETTINGS_URL: string = UserApiConstant.SAVE_ACCOUNT_SETTINGS;
  readonly LAST_REPINIT_TIME_URL: string = UserApiConstant.LAST_REPINIT_CHAT_TIME;
  readonly DISABLE_PROMOTIONPOPUP_URL: string = UserApiConstant.DISABLE_PROMOTION_POPUP;
  /******************Properties******************/

  /***************Constructor***************/
  constructor(config: AppConfig) {
    super(config, Configuration.USER_API_ENDPOINT);
    this.reset(this);
  }
  /***************Constructor***************/
}
